import { render, staticRenderFns } from "./addTestBlock.vue?vue&type=template&id=b452026e&scoped=true"
import script from "./addTestBlock.vue?vue&type=script&lang=js"
export * from "./addTestBlock.vue?vue&type=script&lang=js"
import style0 from "./addTestBlock.vue?vue&type=style&index=0&id=b452026e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b452026e",
  null
  
)

export default component.exports